<script lang="ts">
    import Switch from "./Switch.svelte";
    import {OfferItem} from "../entities/OfferItem";
    import {ModelType} from "../entities/Model";
    export let offerItem: OfferItem
    export let updateFormData: Function
    let rotated
    $: {
        rotated = offerItem.measuredModel.canRotate
    }
</script>

<h2 class=" bg-blue-600 text-2xl rounded font-semibold inline p-2">{offerItem.measuredModel.model.name}</h2>

<p class="text-sm py-4 mb-4 text-justify">{offerItem.measuredModel.model.description}</p>
<div class="flex justify-around lg:justify-start flex-row mb-2 lg:flex-col">
        <div class="flex flex-col space-y-4">
            <!--<Switch clicked={(active) => updateFormData({ freestanding: active })} active={offerItem.freestanding}/>-->
                <div>
                    <div class="border-2 my-1 rounded-2xl" style="border-color:#FF5733">
                        <input class="flex p-1 m-0 w-full bg-transparent text-center text-white font-bold text-2xl p-0 border-0 outline-none"
                               type="number" min="250" max="2400" value={offerItem.widthValue}
                               on:input={(ev) => {
                                    if (ev.target.value > 2000) {
                                          ev.target.value = 2000
                                    }
                                    if(parseInt(ev.target.value) !== offerItem.widthValue && (offerItem.measuredModel.model.type === ModelType.BIOCLIMATIC && ev.target.value >= 200) || offerItem.measuredModel.model.type === ModelType.PVC && ev.target.value >= 250 ) {
                                        updateFormData({ widthValue: parseInt(ev.target.value)})
                                    }}
                               }
                        />
                    </div>
                    <p class="text-sm font-semibold">Sárga - Szélesség (cm)</p>
                </div>
                <div class="w-max">
                    <div class="border-2 my-1 rounded-2xl" style="border-color:#696DEA">
                        <input class="flex p-1 m-0 w-full bg-transparent text-center text-white font-bold text-2xl p-0 border-0 outline-none"
                               type="number" min="200" max="1000" value={offerItem.projectionValue}
                               on:input={(ev) => {
                                   if (offerItem.measuredModel.model.type === ModelType.PVC && ev.target.value > offerItem.measuredModel.model.maxProjection) {
                                       ev.target.value = offerItem.measuredModel.model.maxProjection
                                   } else if (ev.target.value > 2000) {
                                       ev.target.value = 2000
                                   }
                                   if(ev.target.value !== offerItem.projectionValue && ev.target.value > 150) {
                                       updateFormData({ projectionValue: parseInt(ev.target.value)})
                                   }
                               }}/>
                    </div>
                    <p class="text-sm font-semibold">Kék - Mélység (cm)</p>
                </div>
            {#if rotated === true}
                <div class="text-sm p-0">
                    Az automatikus elforgatás kikapcsolásával több modulra lesz szüksége, ami többletköltséggel járhat.
                </div>
                <Switch clicked={(clicked) => updateFormData({ shouldRotate:clicked})} active={offerItem.shouldRotate}/>
            {/if}
            <p class="text-xs">Közelíteni vagy távolítani a <kbd class="border px-0.5 py-1 rounded">Ctrl</kbd> + <kbd class="border px-0.5 py-1 rounded">Görgő</kbd> használatával tud. A 3D megjelenítés mindösszesen koncepció. A színek és a részletek a valóságban eltérhetnek.</p>
        </div>
</div>